import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
  selector: 'gd-type-editor-assistant-type',
  templateUrl: './type-editor-assistant-type.component.html',
  styleUrls: ['./type-editor-assistant-type.component.scss'],
  imports: [
    CommonModule,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    ColumnComponent,
    EditTemplateDirective,
    TextBoxDirective,
    FormsModule,
    ReactiveFormsModule,
    CellTemplateDirective,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
  ]
})
export class TypeEditorAssistantTypeComponent extends GridEditorBaseComponent {
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getAssistantLookups().subscribe((response) => {
      this.repState.assistantLookups = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const assistantType = formGroup.value
    this.typesService
      .submitAssistantLevelUpdate(assistantType)
      .subscribe(() => {
        sender.closeRow(rowIndex)
        this.initGrid()
      })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        assistantLevelID: 0,
        infoLevel: null,
        active: true,
      },
    )
  }
  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(assistantType: any): UntypedFormGroup {
    return this.formBuilder.group({
      assistantLevelID: assistantType.assistantLevelID,
      infoLevel: [assistantType.infoLevel, Validators.required],
      active: assistantType.active,
    })
  }
}
